/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-11-29 16:43:42
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-12-01 15:18:46
 * @FilePath: \mystudy\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'leaflet/dist/leaflet.css'
// import 'leaflet.pm'
// import 'leaflet.pm/dist/leaflet.pm.css'
// import 'leaflet/dist/leaflet.css'
Vue.use(Vant);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
